import React from 'react';
import PropTypes from 'prop-types';

export default function ShadowDocumentUsageDetails({ shadow }) {
  return (
    <div className="shadow-document-usage-details">
      <table>
        <tbody>
          {shadow.documentUsage.map(usage => (
            <tr key={usage.document.id}>
              <td className="document-name">
                {usage.document.name}
              </td>

              <td className="page-numbers">
                <label className="label sm pill-label">
                  Page {usage.pageNumbers.join(', ')}
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ShadowDocumentUsageDetails.propTypes = {
  shadow: PropTypes.shape({
    documentUsage: PropTypes.arrayOf(PropTypes.shape({
      document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
      pageNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,
    })).isRequired,
  }).isRequired,
};
